import Link from "next/link";

import { PostFragment } from "../interfaces";
import BlurImage from "./BlurImage";

type Props = {
  post: PostFragment;
};

const PostListing = ({ post }: Props) => {
  return (
    <Link href={"/blog/" + post.seo.slug}>
      <div className="bg-white cursor-pointer">
        <div className="mx-auto max-w-7xl sm:px-2 lg:px-4">
          <div className="max-w-2xl px-4 mx-auto lg:max-w-none">
            <div className="py-5 space-y-16">
              <div className="flex flex-col lg:grid lg:grid-cols-12 lg:gap-x-8 lg:items-center">
                <div className="flex-auto lg:col-span-5 xl:col-span-5">
                  <div className="overflow-hidden bg-gray-100 rounded-lg aspect-w-5 aspect-h-2">
                    <BlurImage
                      src={post.image?.url || "/logo-with-background.png"}
                      alt={post.imageAlt || post.title}
                      className="object-cover object-center rounded-xl"
                      fill
                      sizes="(max-width: 768px) 95vw,
                              (max-width: 1200px) 33vw,
                              33vw"
                    />
                  </div>
                </div>
                <div className="mt-6 lg:mt-0 lg:col-span-7 xl:col-span-7">
                  <h3 className="text-lg font-medium text-gray-900">
                    {post.title}
                  </h3>
                  <p className="mt-2 text-sm text-gray-500">
                    {post.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PostListing;
